const ig = (n) => `/images/ig/${n}.jpg`;
const range = (pre, n) => Array.from({ length: n }, (_, i) => ig(`${pre}_${i + 1}`));

export const PROJECTS = [
  {
    id: "padstow", suburb: "Padstow", title: "Padstow Mediterranean duplex", image: ig("p7"),
    note: "Plumbing for curved showers, crazy-pave wet areas and premium tapware throughout a Mediterranean-style duplex.",
    credits: "Designed by Dezcon · Built by Pier 8 Constructions · Render by Dezcon",
    gallery: [ig("p7"), ig("p5"), ig("p6"), ig("p4"), "/images/projects/padstow-render.jpg"],
    video: {
      id: "tXhe43fcoJw", thumb: "/images/projects/padstow-render.jpg", title: "Padstow Mediterranean duplex walkthrough",
      heading: "See the finished home.",
      caption: "Video walkthrough of the finished duplex by McGrath St George, Shire & South West Group.",
    },
  },
  {
    id: "hurstville", suburb: "Hurstville", title: "Hurstville luxury home", image: "/images/projects/hurstville/master-bath.jpg",
    note: "Plumbing fit-off for a stone waterfall island kitchen, freestanding bath and matte-black tapware.",
    gallery: ["master-bath", "kitchen", "powder-room"].map((n) => `/images/projects/hurstville/${n}.jpg`),
  },
  {
    id: "beverly-park", suburb: "Beverly Park", title: "Beverly Park luxury duplex", image: "/images/projects/beverly-park/kitchen.jpg",
    note: "Kitchen and bathroom plumbing fit-off for a contemporary duplex, including the integrated sink and premium tapware.",
    gallery: ["kitchen", "facade"].map((n) => `/images/projects/beverly-park/${n}.jpg`),
  },
  {
    id: "connells-point", suburb: "Connells Point", title: "Connells Point luxury home", image: "/images/projects/connells-point/bathroom.jpg",
    note: "Plumbing fit-off for a marble island kitchen and a stone bathroom with twin basins, bath and rail shower.",
    gallery: ["bathroom", "kitchen", "facade"].map((n) => `/images/projects/connells-point/${n}.jpg`),
  },
  {
    id: "panania", suburb: "Panania", title: "Panania luxury duplex", image: ig("p1_6"),
    note: "Kitchen and bathroom plumbing, planned with the client so every fixture is functional and practical.",
    credits: "Designed by Dezcon · Built by Allura Group",
    gallery: [ig("p1_6"), ig("p1"), ...range("p1", 19).filter((s) => !s.endsWith("p1_6.jpg"))],
  },
  {
    id: "cronulla", suburb: "Cronulla", title: "Cronulla coastal home", image: ig("p10_11"),
    note: "Bathroom, ensuite and kitchen plumbing fitted off to a luxury finish among timber, stone and brass.",
    gallery: [ig("p10_11"), ...[3, 9, 6, 2, 8, 12, 13, 14, 15, 4, 7, 5].map((k) => ig(`p10_${k}`))],
  },
  {
    id: "details", suburb: "Sydney", title: "Signature details", image: ig("p3"),
    note: "Detail is everything — stone and tapware finished properly.",
    gallery: ["p3", "p10_15", "p1", "p1_11", "p1_4", "p1_8", "p1_5"].map(ig),
  },
];

export const projectFor = (suburb) => PROJECTS.find((p) => p.suburb === suburb);
